export class ContactOwnerRawDto {
  ownerIdentifier: string;
  firstName: string;
  lastName: string;
}
